import {app} from "@tva/app";
import {downgradeComponent} from "@angular/upgrade/static";
import * as angular from "angular";
import {CreManagementComponent} from "@tva/ng-migration/cre-tracking/components/search/cre-management.component";

app.directive(
  "appCreManagement",
  downgradeComponent({
    component: CreManagementComponent,
  }) as angular.IDirectiveFactory
);
